module.exports = __webpack_public_path__ + "static/kuba-avatar-0c05682889056f5f01d4800758a5e0d3.webp";